import { BREAKPOINT_DEFINITIONS } from '../constants/config.js';
import { detectBrowser } from './detectBrowser.js';

let isSafari = detectBrowser() === 'Apple Safari';

export function getBreakpoint(value) {
	if (!value) {
    value = isSafari ? document.documentElement.clientWidth || document.body.clientWidth : window.innerWidth;
  }

	const keys = Object.keys(BREAKPOINT_DEFINITIONS)
	    , values = Object.values(BREAKPOINT_DEFINITIONS)
	    , bpVal = Math.max(...values.filter(x => x <= value));
      
	return keys[values.indexOf(bpVal)] || 'xs';
};